<template>
    <div>
        <div class="container order-content">
            <div class="manage-main">
                <div class="rule" style="overflow: hidden">
                    <Menu></Menu>
                    <div class="manage-right">
                        <div class="right-title">交易报表</div>
                        <div class="manage-order manage-report">
                            <div class="input-box">
                                <span>时间条件</span>
                                <div class="select-box">
                                    <select v-model="TimeType">
                                        <option value="0">预订时间</option>
                                        <option value="1">入住时间</option>
                                        <option value="2">离店时间</option>
                                    </select>
                                </div>
                            </div>
                            <div class="input-box">
                                <span>起止时间</span>
                                <input type="text" v-model="Start" @click="calendar.show=true" class="date-time" data-type="time">-<input type="text" v-model="End" @click="calendar.show=true" class="date-time" data-type="time">
                                <DatePicker @select="calendar.select" v-show="calendar.show" :start="calendar.start"
                                            :beginDate="calendar.begin" :endDate="calendar.end">

                                </DatePicker>
                            </div>
                            <div class="input-box">
                                <span>订单编号</span>
                                <input type="text" v-model="OrderNO" maxlength="20">
                                <i v-if="OrderNO!=''" class="iconfont icon-guanbi" @click="OrderNO=''"></i>
                            </div>
                            <div class="input-box">
                                <span>入住人</span>
                                <!--<div class="select-box">-->
                                <!--<select v-model="Oper">-->
                                <!--<option value="1"></option>-->
                                <!--</select>-->
                                <!--</div>-->
                                <input type="text" v-model="GustName" maxlength="50">
                                <i v-if="GustName!=''" class="iconfont icon-guanbi" @click="GustName=''"></i>
                            </div>
                            <div class="input-box">
                                <span>订单来源</span>
                                <div class="select-box">
                                    <select v-model="Source">
                                        <option value="">全部</option>
                                        <option value="0">手机订房易</option>
                                        <option value="1">PC 端订房易</option>
                                        <option value="2">线下客服</option>
                                        <option value="3">API对接</option>
                                    </select>
                                </div>
                            </div>
                            <div class="input-box">
                                <span>支付状态</span>
                                <div class="select-box">
                                    <select v-model="Payment">
                                        <option value="">全部</option>
                                        <option value="0">未支付</option>
                                        <!--<option value="1">处理中</option>-->
                                        <!--<option value="2">未付清</option>-->
                                        <option value="3">已支付</option>
                                        <option value="4">已退款</option>
                                    </select>
                                </div>
                            </div>
                            <div class="btn-box">
                                <div class="btn manage-search" @click="Page = 1;initData()">查询</div>
                                <div class="btn manage-out" @click="export2Excel">导出</div>
                                <a id="dlink"  style="display:none;"></a>

                            </div>
                        </div>
                        <div class="search-result">
                            <p>搜索到<span>{{total}}</span>条符合条件的订单</p>
                            <div class="manage-order manage-report">
                            </div>
                            <table class="result-table" id="table">
                                <thead>
                                <tr>
                                    <td style="width:50px;">编号</td>
                                    <td style="width:137px;">订单编号 <br> 订单来源</td>
                                    <td style="width:162px;">酒店名称</td>
                                    <td style="width:83px;">入住人</td>
                                    <td style="min-width:95px;">入住日期<br/>离店日期</td>
                                    <td style="min-width:95px;">预定时间</td>
                                    <td style="width:75px;">间夜</td>
                                    <td style="min-width:70px;">订单状态</td>
                                    <td style="min-width:94px;">金额 <br>支付状态</td>
                                    <td style="width:65px;">操作员</td>

                                </tr>
                                </thead>
                                <tbody v-if="!isLoading">
                                <tr v-for="(item, index) in ReportList">
                                    <td style="text-align: center">{{index+1}}</td>
                                    <td>
                                        <span class="order-btn" @click="routerToDetails(item.OrderNO)">{{item.OrderNO}}</span><br>
                                        <span v-if="item.Source == 0">手机订房易</span>
                                        <span v-if="item.Source == 1">PC 端订房易</span>
                                        <span v-if="item.Source == 2">线下客服</span>
                                        <span v-if="item.Source == 3">API对接</span>
                                    </td>
                                    <td>{{item.HotelName}}</td>
                                    <td><span style="max-width: 119px" v-for="i in item.Guest">{{i.FirstName+i.LastName}},<br></span></td>
                                    <td>
                                        <span>{{item.CheckIn|dateToYMDline}}</span><br>
                                        <span>{{item.CheckOut|dateToYMDline}}</span>
                                    </td>
                                    <td>
                                        <span>{{item.BookingOn|dateToYMDline}}</span><br>
                                        <span>{{item.BookingOn|dateHMS}}</span>
                                    </td>
                                    <td style="text-align: center">{{item.RoomCount}}间 {{item.NightCount}}夜</td>
                                    <td style="text-align: center">
                                        <span v-if="item.Status == 0">无效单</span>
                                        <span v-if="item.Status == 2">已锁定</span>
                                        <span v-if="item.Status == 9">新单</span>
                                        <span v-if="item.Status == 8">取消单</span>
                                        <span v-if="item.Status == 10">已确认</span>
                                        <span v-if="item.Status == 27">可入住</span>
                                        <span v-if="item.Status == 30">罚金取消</span>
                                    </td>

                                    <td>
                                        <span class="price">{{item.Currency}}{{item.TotalAmount}}</span><br>
                                        <span v-if="item.PaymentType == 0">未支付</span>
                                        <span v-if="item.PaymentType == 1">未支付</span>
                                        <span v-if="item.PaymentType == 2">未支付</span>
                                        <span v-if="item.PaymentType == 3">已支付</span>
                                        <span v-if="item.PaymentType == 4">已退款</span>
                                        <span v-if="item.PaymentType == 5">罚金取消</span>
                                    </td>
                                    <td>{{item.Creator}}</td>
                                </tr>
                                </tbody>
                            </table>
                            <div class="table-loading" v-if="isLoading">
                                <Loading :isLoading="isLoading"></Loading>
                            </div>
                            <div class="table-no-more" style="width: 100%" v-if="!isLoading&&total ==0">
                                暂无数据...
                            </div>
                        </div>
                        <Paginate :pageIndex="Page" :pageTotal="Math.ceil(total/PageSize)" @select="pageSelect" v-if="total>10"></Paginate>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DatePicker from './../../common/cmpnt/datePicker/datePicker.vue'//日期
    import Loading from './../../common/cmpnt/Loading/Loading.vue'//缓冲
    import Menu from './../../common/cmpnt/menu/Menu'
    import Paginate from './../../common/cmpnt/paginate/paginate.vue'//分页

    export default {
        name: "ReportList",
        components: {
            DatePicker,
            Loading,
            Menu,
            Paginate
        },
        data: function () {
            return {
                Start: this.getDate(-5),
                End: this.getDate(2),
                OrderNO:'',
                TimeType:0,
                GustName:'',
                total:0,
                Source:'',
                ReportList:[],
                isLoading:false,
                Payment:'',
                PaymentType:[],
                Page: 1,
                PageSize: 10,
                calendar: {
                    show: false,
                    start: '',
                    begin: this.getDate(-5),
                    end: this.getDate(2),
                    select: (begin, end) => {
                        if (!begin) {
                            this.calendar.show = false;
                            this.calendar.begin = this.Start;
                            this.calendar.end = this.End;
                            return;
                        }

                        this.calendar.begin = begin;
                        this.calendar.end = end;
                        this.Start = begin;
                        this.End = end;
                        this.$nextTick(function () {
                            this.calendar.show = false;
                            // this.changeFilter();
                        });
                    }
                }
            }
        },
        watch:{
            Payment(key){
                if(key === ''){
                    this.PaymentType = [];
                }else if(key==='0'){
                    this.PaymentType = [0,1,2]
                }else if(key>2){
                    this.PaymentType = [key]
                }
            }
        },
        mounted() {
            this.initData();
            document.title='交易报表---订房易';
            var that = this
            that.$nextTick(() => {
                if(localStorage.getItem('lang')=='t'){
                    that.$zh_tran(localStorage.getItem('lang'))
                }        
            })
        },
        methods: {
            pageSelect(val){
                this.total=0;
                this.ReportList=[];
                this.Page=val;
                this.initData();
            },
            routerToDetails(id){
                const {href} = this.$router.resolve({
                    name: 'OrderDetails',
                    params: { orderNO: id}
                })
                window.open(href, '_blank')
            },
            export2Excel() {
                var that = this;
                var params = {
                    TimeType: that.TimeType,
                    OrderNO: that.OrderNO,
                    ThirdOrderNO: '',
                    GustName: that.GustName,
                    HotelName: '',
                    Start: that.Start,
                    End: that.End,
                    Oper: '',
                    Source: that.Source,
                    Status: [],
                    PaymentType: that.PaymentType,
                    Page: 1,
                    PageSize: 9999,
                }
                that.postRequest({
                    url: that.Api.getOrderReport,
                    params: params
                }).then(res => {
                    that.isLoading = false;
                    if (res && res.IsSuccess) {
                        // that.total = res.Total;
                        // that.ReportList = res.Result
                        
                        require.ensure([], () => {
                            const { export_json_to_excel } = require('../../common/excel/Export2Excel'); //这里必须使用绝对路径
                            const tHeader = ['CN单号','订单来源','入住日期', '离店日期', '酒店','入住人','间夜','订单金额 ','币种','支付状态','订单状态','跟单人','预定日期','操作员']; // 导出的表头名
                            const filterVal = ['OrderNO','Source','CheckIn','CheckOut', 'HotelName','Guest','RoomCount','RoomPrice','Currency','PaymentType','Status','Oper','BookingOn','Creator']; // 导出的表头字段名
                            const list = that.tableExcelData(res.Result);
                            const data = that.formatJson(filterVal, list);
                            export_json_to_excel(tHeader, data, '订单列表');// 导出的表格名称，根据需要自己命名
                        })
                    } else {
                        that.error({title: '提示', content: res.Msg || '数据搜索失败'});
                    }
                });
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            tableExcelData(list){
                var l = [];
                for(let i=0; i<list.length; i++){
                    var lis = {
                        OrderNO:list[i].OrderNO,
                        HotelName:list[i].HotelName,
                        RoomName:list[i].RoomName,
                        RoomCount:list[i].RoomCount+'间 '+list[i].NightCount+'夜',
                        Oper:list[i].Oper,
                        Creator:list[i].Creator,
                        RoomPrice: list[i].TotalAmount,
                        Currency: list[i].Currency,
                        CheckIn: this.filterDateToYMDline(list[i].CheckIn),
                        CheckOut: this.filterDateToYMDline(list[i].CheckOut),
                        BookingOn: this.filterDateToYMDline(list[i].BookingOn),
                        PaymentType: list[i].PaymentType == 0 ? '未支付' : list[i].PaymentType == 1 ? '未支付' : list[i].PaymentType == 2 ? '未支付' : list[i].PaymentType == 3 ? '已支付' : list[i].PaymentType == 4 ? '已退款' :list[i].PaymentType == 5 ? '罚金取消' : '',
                        Status: list[i].Status == 0 ? '无效单' : list[i].Status == 8 ? '取消单' : list[i].Status == 9 ? '新单' : list[i].Status == 10 ? '已确认' : list[i].Status == 27 ? '可入住' :list[i].Status == 30 ?'罚金取消': '',
                        Guest:'',
                        Source: list[i].Source == 0?'手机订房易':list[i].Source ==1?'PC 端订房易':list[i].Source == 2?'线下客服':list[i].Source == 3?'API接口':'',
                    };
                    var guest = '';
                    for(let j=0; j< list[i].Guest.length; j++){
                        guest = guest + list[i].Guest[j].FirstName + list[i].Guest[j].LastName + '、';
                    }
                    lis.Guest = guest;
                    l.push(lis)
                }
                return l
            },
            filterDateToYMDline(date) {
                if (!date) return '';
                var da = new Date(date);
                var year = da.getFullYear();
                var month = da.getMonth() + 1;
                var day = da.getDate();
                if (month < 10) {
                    month = '0' + month
                };
                if (day < 10) {
                    day = '0' + day
                };
                return year + '-' + month + '-' + day;
            },
            initData(){
                var that = this;
                this.isLoading = true;
                var params = {
                    TimeType: that.TimeType,
                    OrderNO: that.OrderNO,
                    ThirdOrderNO: '',
                    GustName: that.GustName,
                    HotelName: '',
                    Start: that.Start,
                    End: that.End,
                    Oper: '',
                    Source: that.Source,
                    Status: [],
                    PaymentType: that.PaymentType,
                    Page: that.Page,
                    PageSize: that.PageSize,
                }
                that.postRequest({
                    url: that.Api.getOrderReport,
                    params: params
                }).then(res => {
                    that.isLoading = false;
                    if (res && res.IsSuccess) {
                        that.total = res.Total;
                        that.ReportList = res.Result
                        that.$nextTick(() => {
                            if(localStorage.getItem('lang')=='t'){
                                that.$zh_tran(localStorage.getItem('lang'))
                            }        
                        })
                    } else {
                        that.error({title: '提示', content: res.Msg || '数据搜索失败'});
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/report/List.vue